import React, { useEffect, useState } from "react";
import "react-circular-progressbar/dist/styles.css";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../Axios.jsx";
import { IndividualProgressTable } from "../components/IndividualProgressTable/IndividualProgressTable.jsx";
import useAuth from "../contexts/UserContext.tsx";
import { selectCourseName } from "../features/student/studentSlice.js";
import { Paper, TableContainer } from "@mui/material";
import { CircularProgressbar } from "react-circular-progressbar";

export const IndividualStudentProgressWidget = ({
  individualStudentDetails,
  schoolID,
}) => {
  const courseName = useSelector(selectCourseName);
  const { user } = useAuth();
  useNavigate();
  // const { id, course_id, name } = useParams();
  const id = individualStudentDetails.studentID;
  const course_id = individualStudentDetails.course;
  const name = individualStudentDetails.studentName;

  const [individualData, setIndividualData] = useState();
  const [exerciseDetailsArray, setExerciseDetailsArray] = useState();

  const getIndividualStudentProgress = async () => {
    try {
      const res = await axiosInstance.post("/getStudentProgress", {
        auth_token: user.auth_token,
        crs_id: course_id,
        student_id: id,
        student_name: name,
      });
      setIndividualData(res.data.data.student_excs_details);
      convertObjectToArray(res.data.data.student_excs_details.excs_details);
    } catch (err) {
      console.error(err.message);
    }
  };

  const convertObjectToArray = (data) => {
    const newArray = Object.keys(data).map((key) => ({
      id: key,
      ...data[key],
    }));
    setExerciseDetailsArray(newArray);
  };

  useEffect(() => {
    getIndividualStudentProgress();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <TableContainer component={Paper} className="mt-1 mx-2">
      <div className="individual-student-progress-container p-3">
        {individualData && (
          <>
            <div className="p-1 flex flex-col">
              <div className="flex">
                <div className="w-full flex flex-col items-center">
                  <div className="text-center text-3xl font-bold capitalize">
                    {name}
                  </div>
                  <div className="text-gray-500 text-xl mb-2">{courseName}</div>
                </div>
              </div>
              <div className="flex justify-center gap-20 mx-40">
                <div className="flex justify-center items-center text-2xl font-semibold">
                  Overall Progress
                </div>
                <div className="h-40 w-40 text-center mb-2">
                  <CircularProgressbar
                    value={individualData.percentage_complete}
                    text={`${individualData.percentage_complete}%`}
                  />
                </div>
              </div>
            </div>
            <div className="max-h-80">
              <IndividualProgressTable
                student_id={id}
                data={exerciseDetailsArray}
              />
            </div>
          </>
        )}
      </div>
    </TableContainer>
  );
};
